export default function Loading() {
  return (
    <div className="w-full h-64 flex justify-center items-center">
      <div className="loader-black" />
    </div>
  );
}
